var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .direct-arrow-triangle {\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .direct-arrow-triangle, .direct-arrow-rectngle {\n        fill: currentColor;\n        stroke: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "direct-arrow-rectngle",
    x: 3.12,
    y: 19.78,
    width: 26.03,
    height: 10.41,
    rx: 3.12,
    ry: 3.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "direct-arrow-triangle",
    d: "M25.29,39.17l19.04-13.33c.59-.41.59-1.29,0-1.71l-19.04-13.33c-.69-.48-1.64.01-1.64.85v26.66c0,.84.95,1.34,1.64.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconArrowWhite);
export default __webpack_public_path__ + "static/media/cloud_icon_arrow_white.15c5adca4daa001174d043e31c73e24f.svg";
export { ForwardRef as ReactComponent };